
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'QuoteActions',
    data() {
        return {};
    },
    props: {
        id: {
            type: String
        }
    },
    async setup(props: any, { emit }: any) {
        const back = () => {
            emit('close');
        };

        function onSelectQuoteAction(action: string) {
            emit('onSelectQuoteAction', action);
            emit('close');
        }

        return {
            props,
            back,
            onSelectQuoteAction
        };
    }
});
